import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-sm border px-2 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-[rgba(26,76,124,0.2)] bg-[rgba(26,76,124,0.08)] text-[#1A4C7C]",
        secondary:
          "border-[rgba(92,107,122,0.2)] bg-[rgba(92,107,122,0.08)] text-[#5C6B7A]",
        destructive:
          "border-[rgba(226,75,74,0.2)] bg-[rgba(226,75,74,0.08)] text-[#E24B4A]",
        outline: "border-[rgba(92,107,122,0.25)] text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
